import InteractiveAnnotation from "./interactiveAnnotation";
import Line from "./line";
import { drawBoxes, setFontStyle, measureText } from "../canvasUtils";
import MeasurementText from "./measurementText";

export default class LengthLine extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);

    this.line = new Line(position, options);

    this.delimiterLength = 30;
    this.delimiterWidth = 1;

    this.baseline = "hanging";
    this.textOffset = 10;
    this.measurementText = new MeasurementText();
    this.textActive = false;
  }

  get delimiterAngle() {
    let adjustment = Math.PI / 2;
    if (Math.abs(this.line.angle) > adjustment) adjustment *= -1;
    return this.line.angle + adjustment;
  }

  get delimiterOffset() {
    return {
      x: this.delimiterLength * Math.cos(this.delimiterAngle),
      y: this.delimiterLength * Math.sin(this.delimiterAngle)
    }
  }

  get textOffsetAngle(){
    return this.textContextRotation + Math.PI / 4;
  }

  get textPosition() {
    let useTail = this.line.tailX < this.line.headX;
    let x = useTail ? this.line.tailX : this.line.headX;
    let y = useTail ? this.line.tailY : this.line.headY;
    return { 
      x: x + this.textOffset * Math.cos(this.textOffsetAngle), 
      y: y + this.textOffset * Math.sin(this.textOffsetAngle) };
  }

  get textContextRotation(){
    let adjustment = 0;
    if (Math.abs(this.line.angle) > Math.PI / 2) adjustment += Math.PI;
    return this.line.angle + adjustment;
  }

  get text(){
    let length = this.scale * this.line.length;
    return length.toFixed(2) + " mm";
  }

  get textWidth(){
    return measureText(this.text, this.font);
  }

  draw(ctx) {
    this.line.draw(ctx);
    this.drawDelimiters(ctx);
    this.drawText(ctx);

    if (this.line.isActive) drawBoxes(ctx, this.line.interactionPoints, this.line.transform.zoom);

    if (this.textActive) this.measurementText.drawRotatedTextInteractionBox(ctx)
  }

  drawDelimiters(ctx) {
    ctx.lineWidth = this.delimiterWidth;
    let offset = this.delimiterOffset;

    ctx.beginPath();
    ctx.moveTo(this.line.tailX, this.line.tailY);
    ctx.lineTo(this.line.tailX + offset.x, this.line.tailY + offset.y);
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.moveTo(this.line.headX, this.line.headY);
    ctx.lineTo(this.line.headX + offset.x, this.line.headY + offset.y);
    ctx.stroke();
    ctx.closePath();
  }

  drawText(ctx) {
    setFontStyle(ctx, this);
    let position = this.textPosition;
    this.measurementText.updateAndDrawRotatedText(this.textWidth, this.textSize, ctx, this.text, position.x, position.y, this.textContextRotation);
  }

  isInBounds(x, y) {
    return this.line.isInBounds(x, y) || this.measurementText.isInBoundRotation(x, y);
  }

  mousedown(x, y) {
  if(this.measurementText.isInBoundRotation(x, y))
    this.textActive = true;
  else this.line.mousedown(x, y);
    this.signalReady();
  }

  mousemove(x, y) {
    if(this.textActive) this.measurementText.updateLocation(x, y);
    else this.line.mousemove(x, y);
    this.signalReady();
  }

  deactivate() {
    this.line.clearActiveState();
    this.textActive = false;
    this.signalReady();
  }

  setParentTransform(obj) {
    this.line.setParentTransform(obj);
    this.signalReady();
  }

  setLineWidth(width) {
    this.line.setLineWidth(width);
    this.signalReady();
  }

  updateColor(color) 
  {
    this.line.color = color;
    this.color = color;
  }
}